"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cpSiteUpdatePanel = exports.cpSiteUpdateHeaderImage = exports.cpSiteUpdateGreeting = exports.cpSiteUpdateFundSequencePanel = exports.cpSiteSuccess = exports.cpSiteReset = exports.cpSitePanelList = exports.cpSiteGetHeaderImageList = exports.cpSiteGetHeaderImage = exports.cpSiteGetGreeting = exports.cpSiteGetBuilderSiteById = exports.cpSiteError = exports.cpSiteDeletePanel = exports.cpSiteAddSiteDefault = void 0;
var _cpSite = require("./cpSite.constant");
// @flow

// common success
var cpSiteSuccess = function cpSiteSuccess(actionType, data) {
  return {
    type: _cpSite.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.cpSiteSuccess = cpSiteSuccess;
var cpSiteError = function cpSiteError(actionType, error) {
  return {
    type: _cpSite.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpSiteError = cpSiteError;
var cpSitePanelList = function cpSitePanelList(data) {
  return {
    type: _cpSite.actionTypes.PANEL_LIST,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpSitePanelList = cpSitePanelList;
var cpSiteAddSiteDefault = function cpSiteAddSiteDefault(data) {
  return {
    type: _cpSite.actionTypes.ADD_SITE_DEFAULT,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpSiteAddSiteDefault = cpSiteAddSiteDefault;
var cpSiteUpdateGreeting = function cpSiteUpdateGreeting(data) {
  return {
    type: _cpSite.actionTypes.UPDATE_GREETING,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpSiteUpdateGreeting = cpSiteUpdateGreeting;
var cpSiteUpdateHeaderImage = function cpSiteUpdateHeaderImage(data) {
  return {
    type: _cpSite.actionTypes.UPDATE_HEADER_IMAGE,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpSiteUpdateHeaderImage = cpSiteUpdateHeaderImage;
var cpSiteUpdateFundSequencePanel = function cpSiteUpdateFundSequencePanel(data) {
  return {
    type: _cpSite.actionTypes.UPDATE_SEQUENCE_PANEL,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpSiteUpdateFundSequencePanel = cpSiteUpdateFundSequencePanel;
var cpSiteGetHeaderImage = function cpSiteGetHeaderImage(data) {
  return {
    type: _cpSite.actionTypes.GET_HEADER_IMAGE,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.cpSiteGetHeaderImage = cpSiteGetHeaderImage;
var cpSiteGetBuilderSiteById = function cpSiteGetBuilderSiteById(data) {
  return {
    type: _cpSite.actionTypes.GET_BUILDER_SITE_BY_ID,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpSiteGetBuilderSiteById = cpSiteGetBuilderSiteById;
var cpSiteGetGreeting = function cpSiteGetGreeting(data) {
  return {
    type: _cpSite.actionTypes.GET_GREETING,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.cpSiteGetGreeting = cpSiteGetGreeting;
var cpSiteDeletePanel = function cpSiteDeletePanel(data) {
  return {
    type: _cpSite.actionTypes.DELETE_PANEL,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpSiteDeletePanel = cpSiteDeletePanel;
var cpSiteUpdatePanel = function cpSiteUpdatePanel(data) {
  return {
    type: _cpSite.actionTypes.UPDATE_PANEL,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpSiteUpdatePanel = cpSiteUpdatePanel;
var cpSiteGetHeaderImageList = function cpSiteGetHeaderImageList(data) {
  return {
    type: _cpSite.actionTypes.GET_HEADER_IMAGE_LIST,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.cpSiteGetHeaderImageList = cpSiteGetHeaderImageList;
var cpSiteReset = function cpSiteReset() {
  return {
    type: _cpSite.actionTypes.RESET
  };
};
exports.cpSiteReset = cpSiteReset;